module.exports = __webpack_public_path__ + "img/about-phone.027048c9.png";